import {createContext, FC, useState} from "react";

type CompaniesContextType = {
  pageState: [number, React.Dispatch<number>]
  searchState: [string, React.Dispatch<string>]
}

export const CompaniesContext = createContext<CompaniesContextType>(null!);

export const CompaniesContextProvider: FC = ({ children }) => {
  const pageState = useState(1);
  const searchState = useState("");

  return <CompaniesContext.Provider value={{
    pageState,
    searchState
  }}>
    {children}
  </CompaniesContext.Provider>
}
